export const chatKeys = {
  thread: (workspaceId: number, id: number) => ['workspaces', workspaceId, 'threads', 'get', id] as const,
  workspaceThreads: (workspaceId: number) => ['workspaces', workspaceId, 'threads', 'list'] as const,
  threads: (workspaceId: number, { fileId, items }: { fileId?: string; items: number }) =>
    fileId
      ? (['workspaces', workspaceId, 'threads', 'list', { fileId, items }] as const)
      : (['workspaces', workspaceId, 'threads', 'list', { items }] as const),
  threadMessages: (workspaceId: number, threadId: number) =>
    ['workspaces', workspaceId, 'threads', threadId, 'list'] as const,
  messages: (workspaceId: number, threadId: number, { items }: { items: number }) =>
    ['workspaces', workspaceId, 'threads', threadId, 'list', { items }] as const,
  message: (workspaceId: number, threadId: number, id: number) =>
    ['workspaces', workspaceId, 'threads', threadId, 'messages', 'get', id] as const,
}
